/** @jsx jsx */
import React from 'react'
import { Flex, jsx } from 'theme-ui'
import { InfoIcons } from './InfoIcons'
import Text from '~/components/IntlComponents/Text'

export const InfoCard = ({
  title,
  description,
  icon,
  iconColor,
  forwardSx,
}) => {
  return (
    <Flex
      sx={{
        height: '100%',
        backgroundColor: 'waxFlower',
        borderRadius: '12px',
        flexDirection: 'column',
        gap: ['5px', '5px', '10px'],
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        
        ...forwardSx,
      }}
    >
      <h2
        sx={{
          fontSize: ['15px', '22px', '34px'],
          lineHeight: ['24px', '24px', '32px'],
          margin: '0',
          mb: [0, 10],
        }}
      >
        {title}
      </h2>
      <Text
        sx={{
          fontSize: ['11px', '17px', '24px'],
          lineHeight: ['18px', '18px', '40px'],
          px: ['13px', '13px', '10px'],
          mb: ['5px', '5px', '20px'],
        }}
      >
        {description}
      </Text>

      <div
        sx={{
          width: '100%',
          height: ['50px', '60px', '80px'],
        }}
      >
        <InfoIcons icon={icon} color={iconColor} />
      </div>
    </Flex>
  )
}
